export const ACSFilters = Array.from({ length: 22 }, (_, i) => i + 1).map((number) => ({
    text: `ACS ${number}`, value: `ACS ${number}`,
}));

// Generate filter array for 3DSS
export const DSSFilters = Array.from({ length: 28 }, (_, i) => i + 1).map((number) => ({
    text: `3DSS ${number}`, value: `3DSS ${number}`,
}));

export const ProtocolVersionFilters = [
    {
        text: "3DS 2.2.0", value: "3DS 2.2.0"
    },
]

export const PackageStateFilter = [
    {
        text: "Draft", value: 1
    },
    {
        text: "Pending", value: 2
    },
    {
        text: "Returned", value: 3
    },
    {
        text: "Reviewed (Deferred)", value: 4
    },
    {
        text: "Testing (Deferred)", value: 5
    },
    {
        text: "Reviewed", value: 6
    },
    {
        text: "Testing", value: 7
    },
    {
        text: "Canceled", value: 8
    },
    {
        text: "Rejected", value: 9
    },
    {
        text: "Completed", value: 10
    },
]

export const VstsAccessFilters = [
    {
        text: 'Active',
        value: 2
    },
    {
        text: 'Active (Expiring on)',
        value: 7
    },
    {
        text: 'Inactive (No subscription purchased)',
        value: 5
    },
    {
        text: 'Inactive (Subscription paid, access pending)',
        value: 1
    },
    {
        text: 'Inactive (Future start date)',
        value: 6
    },
    {
        text: 'Inactive (Deactivated)',
        value: 4
    },
    {
        text: 'Inactive (Subscription expired)',
        value: 3
    }
]